import type { SlateContent } from 'domains/reporter/Reporter/types';
import type { Descendant } from 'domains/reporter/RichTextEditor/core';
import { Element, Node, Text } from 'domains/reporter/RichTextEditor/core';

export const stripCarriageReturnsFromContent = (
  content: Nullable<SlateContent>
): Nullable<SlateContent> => {
  if (content == null) {
    return content;
  }

  const stripNode = (node: Descendant): Descendant => {
    if (Text.isText(node)) {
      return { ...node, text: node.text.replace(/\r/g, '') };
    }

    if (Element.isElement(node)) {
      return { ...node, children: node.children.map(stripNode) };
    }

    return node;
  };

  return content.map((node: Node) => stripNode(node)) as SlateContent;
};
